import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TournamentHeader from "../AutionDetails/TournamentHeader";
import { useLazyGetSpecificTournamentQuery } from "../../services/tournamentsAPI";
import { getUserPref } from "../../uttils/UserPref";
import Loader from "../../components/Loader";
import CustomTabs from "../AutionDetails/CustomTabs";
import PlayerCard from "../../components/PlayerCard";
import defaultProfile from "../../assets/images/defaultProfile2.webp";
import AuctionTeams from "../AutionDetails/AuctionTeams";
import NoDataView from "../../components/NoDataView";
import SearchInput from "../../components/SearchInput";
import CustomBreadCrumbs from "../AuctionBidding/CustomBreadCrumbs";
import { useNavigate, useSearchParams } from "react-router-dom";
import teamLogo from "../../assets/images/teamDefault.png";

const AuctionData = () => {
  const userData = getUserPref();
  const { tournamentId } = JSON.parse(userData);

  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const [playerData, setPlayerData] = useState([]);
  const [defaultPlayerData, setDefaultPlayerData] = useState([]);
  const [search, setSearch] = useState("");
  const [triggerGetTournament, { data, isLoading }] =
    useLazyGetSpecificTournamentQuery();

  useEffect(() => {
    if (tournamentId) {
      triggerGetTournament({ tournamentId });
    }
  }, [tournamentId, triggerGetTournament]);

  const tournamentData = data?.data?.tournament;

  const players = tournamentData?.teamMembers || [];

  const soldCount = players.filter((p) => p?.isSold).length;
  const unsoldCount = players.filter((p) => p?.isPassed).length;
  const availableCount = players.filter(
    (p) => !p?.isSold && !p?.isPassed
  ).length;

  useEffect(() => {
    const players = data?.data?.tournament?.teamMembers || [];

    if (tab === 3) {
      const list = data?.data?.tournament?.auctionDetails?.auctionTeams || [];
      setDefaultPlayerData(list);
      setPlayerData(list);
      return;
    }

    const filterData = players.filter((ele) => {
      if (tab === 0) return ele?.isSold;
      if (tab === 1) return ele?.isPassed;
      if (tab === 2) return !ele?.isSold && !ele?.isPassed;
      return false;
    });

    setDefaultPlayerData(filterData);
    setPlayerData(filterData);
  }, [tab, data]);

  useEffect(() => {
    if (tab === 3) return;

    const safeSearch = (search || "").trim().toLowerCase();

    if (safeSearch.length === 0) {
      setPlayerData(defaultPlayerData);
      return;
    }

    const filteredPlayers = defaultPlayerData.filter((player) =>
      player?.playerName?.toLowerCase().includes(safeSearch)
    );

    setPlayerData(filteredPlayers);
  }, [search, tab, defaultPlayerData]);

  // console.log("logcheck", playerData[0]);

  if (isLoading) return <Loader />;

  return (
    <Box sx={{ paddingTop: "2rem" }}>
      <TournamentHeader data={tournamentData} />
      <Box sx={{ px: "3rem" }}>
        <CustomBreadCrumbs
          tournamentName={"Auction Data"}
          onBack={() => navigate(-1)}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 2,
          mb: 2,
        }}
      >
        <CustomTabs
          value={tab}
          setValue={setTab}
          arr={[
            `Sold (${soldCount})`,
            `Unsold (${unsoldCount})`,
            `Player Available (${availableCount})`,
            "Team",
          ]}
        />

        <Box sx={{ width: "400px", paddingRight: "20px" }}>
          <SearchInput
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
      </Box>
      {tab === 3 ? (
        <AuctionTeams data={tournamentData} search={search} />
      ) : (
        <Box sx={{ px: "3rem", py: "1.5rem" }}>
          <Grid container columnSpacing={2} rowSpacing={3}>
            {playerData.length > 0 ? (
              playerData.map((player) => (
                <Grid item xs={12} sm={6} md={3} key={player._id}>
                  <PlayerCard
                    name={player.playerName}
                    role={player?.playerId?.roleId}
                    image={player?.playerId?.profilePic || defaultProfile}
                    onView={() => {}}
                    onDelete={() => console.log("delete")}
                    showActions={false}
                    showPurchase={true}
                    purchasedAt={player?.sellingPrice}
                    bidPrice={player?.basePrice}
                    teamLogo={
                      tournamentData?.teams?.filter(
                        (ele) => ele?._id === player?.teamId
                      )?.[0]?.teamLogo || teamLogo
                    }
                    isCaptain={player?.title?.includes("Captain")}
                    isIconPlayer={player?.title?.includes("Icon Player")}
                  />
                </Grid>
              ))
            ) : (
              <NoDataView
                text={tab === 3 ? "No teams found" : "No players found"}
              />
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default AuctionData;
